'use strict';

const h = require('phy');
const SelectLogo = require('./image_logo');

const Information = props => {
  const {
    appliedAtCheckoutText,
    dealProps,
    promoCodeExperimentDesktop = false,
    hideByDefault = true,
    touchRequest,
  } = props;

  if (
    dealProps.soldOutOrExpired ||
    !dealProps.isSelectEligibleDeal ||
    promoCodeExperimentDesktop
  ) {
    return null;
  }

  let classList = '.select-widget';
  if (touchRequest) {
    classList += '.t-pod';
  } else if (dealProps.isSlimPricingDeal) {
    classList += '.select-widget_slim';
  }
  if (hideByDefault) {
    classList += '.hide';
  }

  const bodyHtml = `<span> ${appliedAtCheckoutText} </span>`;

  return h(
    `div${classList}#select-widget-information`,
    {
      'data-bhw': 'SelectInformationWidget',
      'data-bh-viewport': 'respect',
    },
    h(SelectLogo, props),
    h('p.select-widget__body', {
      dangerouslySetInnerHTML: { __html: bodyHtml },
    })
  );
};
module.exports = Information;
